import { Box, Divider, ListItemButton, Stack, Typography } from '@mui/material';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SxProps, Theme } from '@mui/material/styles';
import routeConstants, { Route } from '../shared/constants/Routes';
import { IconCoin, IconLink, IconRefresh } from '@tabler/icons-react';
import usePageBottom from '../hooks/useScrollBottom';
import useVirtualVotingPhase from '../hooks/useVirtualVotingPhase';
import BridgeModal from '../components/modals/BridgeModal';
import { useAppContext } from '../context/AppContext';

const SideNavStyle: SxProps<Theme> = {
  position: 'fixed',
  zIndex: 1,
  height: 'calc(100dvh - 65px)',
  minWidth: 220,
  background: '#FFF',
  borderRight: '1px solid #F2F6F7',
  display: {
    xs: 'none',
    md: 'flex',
  },
  flexDirection: 'column',
  justifyContent: 'space-between',
};

const NavItemStype: SxProps<Theme> = {
  display: 'flex',
  gap: '.5rem',
  color: '#404040',
  fontWeight: 700,
};
const BuyToken: SxProps<Theme> = {
  display: 'flex',
  gap: '.5rem',
  color: '#404040',
  fontWeight: 700,
};

const Menus = [
  routeConstants.HOME,
  routeConstants.GOVERNANCE,
  // routeConstants.STAKER,
  // routeConstants.CONTRIBUTION,
  // routeConstants.VALIDATOR,
  // routeConstants.BUILDER,
];

const SideNav = () => {
  const isVisible = usePageBottom();
  const { hasVirtualOnVotingPhase } = useVirtualVotingPhase();
  const { toggleBridgeModal, setToggleBridgeModal } = useAppContext();

  const renderMenu = () => {
    return (
      <>
        {Menus.map((menu, index) => (
          <NavItem
            key={index}
            {...menu}
            hasVirtualOnVotingPhase={
              hasVirtualOnVotingPhase ? hasVirtualOnVotingPhase : false
            }
          />
        ))}
      </>
    );
  };

  return (
    <Box sx={SideNavStyle}>
      <Box display="flex" flexDirection="column" flex={1} padding={2}>
        <Stack>{renderMenu()}</Stack>
        <Divider sx={{ marginY: 2 }} />
        <Stack>
          <ListItemButton
            sx={BuyToken}
            onClick={() => {
              const url =
                process.env.REACT_APP_ENVIRONMENT === 'production'
                  ? `https://aerodrome.finance/swap?from=eth&to=${process.env.REACT_APP_TOKEN_ADDRESS}`
                  : `https://dexscreener.com/base/${process.env.REACT_APP_TOKEN_ADDRESS}`;
              window.open(url, '_blank');
            }}
          >
            <IconCoin />
            <Typography fontSize={14}>Buy Token</Typography>
          </ListItemButton>

          <ListItemButton
            sx={BuyToken}
            onClick={() => setToggleBridgeModal(true)}
          >
            <IconLink />
            <Typography fontSize={14}>Bridge</Typography>
          </ListItemButton>

          <Box>
            {isVisible ? (
              <Box
                sx={{
                  height: '203px',
                }}
              ></Box>
            ) : null}
          </Box>
        </Stack>
      </Box>
      <BridgeModal
        open={toggleBridgeModal}
        onClose={() => setToggleBridgeModal(false)}
      />
    </Box>
  );
};

const NavItem: React.FC<Route> = (props) => {
  const { pathname } = useLocation();

  return (
    <Link
      to={props.path}
      target={props.title === 'Governance Forum' ? '_blank' : '_self'}
      style={{ textDecoration: 'none' }}
    >
      <ListItemButton
        sx={{
          ...NavItemStype,
          background: props.path === pathname ? '#F0FCFE' : undefined,
          color: props.path === pathname ? '#1D818F' : '#404040',
        }}
      >
        {props.icon}
        <Typography
          fontSize={14}
          fontWeight={props.path === pathname ? 'bold' : 400}
        >
          {props.title}
        </Typography>
        {props.title === 'Governance Forum' &&
          props.hasVirtualOnVotingPhase && (
            <span
              style={{
                position: 'absolute',
                top: '5px', // Adjust as needed for proper positioning
                right: '15px', // Adjust as needed for proper positioning
                width: '7px',
                height: '7px',
                borderRadius: '50%',
                backgroundColor: 'red',
              }}
            ></span>
          )}
      </ListItemButton>
    </Link>
  );
};

export default SideNav;
